import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { MenuRounded } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";

import { isInsideGoReactNativeApp } from "commons/src/helpers/ReactNativeAppHelpers";
import { useComponentState } from "commons/src/helpers/CustomHooks";
import { stopImpersonatingClient } from "commons/src/helpers/adviserViewHelpers";

import { Sidebar } from "./Sidebar";
import { AdviserViewHeader } from "./AdviserViewHeader";
import { logout } from "./DataOperations";
import { routes } from "../helpers/RouteHelpers";
import { Message } from "./Message";

export function Header({ theme = {} }) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [componentState, changeStateTo, { LOADING, ERROR }] = useComponentState();

    const dispatch = useDispatch();

    const { logo, isBranded } = theme;

    if (isInsideGoReactNativeApp()) {
        return null;
    }

    const handleClientSwitch = async () => {
        try {
            changeStateTo(LOADING);
            await dispatch(stopImpersonatingClient());
        } catch {
            changeStateTo(ERROR);
        }
    };

    return (
        <>
            <HeaderParent data-testid="header-parent">
                <Link to={routes.client.root()}>
                    <Logo src={logo} />
                </Link>
                <AdviserViewHeader
                    handleClientSwitch={handleClientSwitch}
                    isStoppingImpersonation={componentState === LOADING}
                />
                <Sidebar
                    isOpen={isSidebarOpen}
                    isBranded={isBranded}
                    closeSidebar={() => setIsSidebarOpen(false)}
                    logout={logout}
                />
                <IconButton
                    color="primary"
                    onClick={() => setIsSidebarOpen(true)}
                    data-testid="open-sidebar-button"
                    aria-label="open sidebar"
                    size="large"
                >
                    <MenuRounded fontSize="large" />
                </IconButton>
            </HeaderParent>
            {componentState === ERROR ? (
                <MessageContainer>
                    <Message text="Something went wrong while switching clients, please try again" />
                </MessageContainer>
            ) : null}
        </>
    );
}

const HeaderParent = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props => props.theme.tertiary};
    padding-right: 1rem;
    z-index: 10;
    width: 100%;
    flex-shrink: 0;

    @media (max-width: ${props => props.theme.maxWidth}) {
        flex-wrap: wrap;
    }

    @media print {
        display: none;
    }
`;

const Logo = styled.img`
    max-width: 160px;
    padding: 0.8em;

    @media (min-width: ${props => props.theme.minWidth}) {
        max-height: ${props => props.theme.topBarHeightDesktop};
    }

    @media (max-width: ${props => props.theme.maxWidth}) {
        max-height: ${props => props.theme.topBarHeightMobile};
    }
`;

const MessageContainer = styled.div`
    padding: 0 1rem 1rem 1rem;
    background: ${props => props.theme.tertiary};
`;

Header.propTypes = {
    theme: PropTypes.object
};
